import { PET_DELETE, PET_OPTIONS } from 'src/constants/actionTypes';

import { post, del } from 'src/actions/actionCreators';

export const deletePet = meta => del(PET_DELETE, `/pets/${meta.id}`, meta);
export const fetchPlans = pets => post(PET_OPTIONS, '/pets/options', pets);
